/*eslint-disable*/
import { Tag } from 'antd'
import React from 'react'
import FadeIn from 'react-fade-in'
import { useTranslation } from 'react-i18next'
import JobItem from './JobItem'

export default ({ list, theme, selectedFilters }) => {
  const { t } = useTranslation(['careers'], {
    useSuspense: false,
  })

  return (
    <div className="job-list">
      <h2
        style={{
          margin: '20px',
          display: 'block',
          fontSize: 18,
          fontWeight: '500',
        }}
      >
        {list.length === 0 && t('careers:jobList.noResult')}
        {list.length >= 1 &&
          t('careers:jobList.numberOpenRoles', {
            amount: list.length,
            withS: list.length > 1 ? 's' : '',
          })}
        <div style={{ display: 'flex', flexWrap: 'wrap', rowGap: 3 }}>
          {selectedFilters.map((el) => (
            <Tag>{el}</Tag>
          ))}
        </div>
      </h2>
      <FadeIn>
        {list?.map((job) => (
          <JobItem
            job={job}
            key={job._id}
            theme={theme}
            id={job._id}
            description={job.description}
            title={job.displayName || job.name}
            contractType={job.contractType}
            location={job.location}
            createdAt={job.createdAt}
          />
        ))}
      </FadeIn>
    </div>
  )
}
